// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { auditOperation } from './AuditOperation';
import { operatorId } from './Operator';
import { z } from 'zod';
export const mediumRecipeComponentHistoryHistoryId = (z.string());
export const mediumRecipeComponentHistory = z.object({
    history_id: mediumRecipeComponentHistoryHistoryId,
    record_id: z.number(),
    schema_version: z.number(),
    record_data: z.unknown(),
    changed_fields: z.unknown().nullable(),
    valid_from: z.date(),
    valid_to: z.date(),
    operation: auditOperation,
    changed_at: z.date(),
    changed_by: operatorId.nullable(),
    change_reason: z.string().nullable(),
});
export const mediumRecipeComponentHistoryInitializer = z.object({
    history_id: mediumRecipeComponentHistoryHistoryId.optional(),
    record_id: z.number(),
    schema_version: z.number().optional(),
    record_data: z.unknown(),
    changed_fields: z.unknown().optional().nullable(),
    valid_from: z.date(),
    valid_to: z.date().optional(),
    operation: auditOperation,
    changed_at: z.date().optional(),
    changed_by: operatorId.optional().nullable(),
    change_reason: z.string().optional().nullable(),
});
export const mediumRecipeComponentHistoryMutator = z.object({
    history_id: mediumRecipeComponentHistoryHistoryId.optional(),
    record_id: z.number().optional(),
    schema_version: z.number().optional(),
    record_data: z.unknown().optional(),
    changed_fields: z.unknown().optional().nullable(),
    valid_from: z.date().optional(),
    valid_to: z.date().optional(),
    operation: auditOperation.optional(),
    changed_at: z.date().optional(),
    changed_by: operatorId.optional().nullable(),
    change_reason: z.string().optional().nullable(),
});
//# sourceMappingURL=MediumRecipeComponentHistory.js.map